import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-bulleted-list',
    templateUrl: './block-bulleted-list.component.html',
})

export class BlockBulletedListComponent extends BlockAbstractComponent implements OnInit {
}
